import ViewAllRetreatsComponent from '../../../containers/Common/ViewAllRetreats'
const ViewAllRetreats = () => {
  return <div>
    <ViewAllRetreatsComponent />
  </div>
}
export default ViewAllRetreats
